import { PromotionStatus } from "../../../../redux/type";

const STATUS_STYLES: Record<
  PromotionStatus,
  { dot: string; text: string; label: string }
> = {
  active: { dot: "bg-[#16A34A]", text: "text-[#16A34A]", label: "Active" },
  draft: { dot: "bg-[#71717A]", text: "text-[#71717A]", label: "Draft" },
  paused: { dot: "bg-[#D97706]", text: "text-[#D97706]", label: "Paused" },
  expired: { dot: "bg-[#DC2626]", text: "text-[#DC2626]", label: "Expired" },
};

interface CampaignStatusBadgeProps {
  status: PromotionStatus;
}

export default function CampaignStatusBadge({ status }: CampaignStatusBadgeProps) {
  const styles = STATUS_STYLES[status] || {
    dot: "bg-[#71717A]",
    text: "text-[#71717A]",
    label: status || "Unknown",
  };

  return (
    <span className={`inline-flex items-center gap-[6px] text-[13px] font-medium ${styles.text}`}>
      <span className={`size-[6px] rounded-full ${styles.dot}`} />
      {styles.label}
    </span>
  );
}
